// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"alert_alertWrapper__1NfLT","fixed":"alert_fixed__3WQ_I"};